import React from 'react';
import { Link } from 'react-router-dom';
import { LogoSantaClara } from '../components/icons/LogoSantaClara';

export default function TenantFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 pt-16 pb-8 mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <LogoSantaClara className="h-8 w-auto text-white" />
            </Link>
            <p className="text-white/64 text-sm leading-relaxed">
              Atención médica cercana, segura y coordinada para Nueva Esperanza y la región.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Navegación</h3>
            <ul className="space-y-3">
              {[
                { label: 'Inicio', path: '/' },
                { label: 'Médicos', path: '/medicos' },
                { label: 'Agendar consulta', path: '/agenda' },
                { label: 'Nosotros', path: '/nosotros' },
                { label: 'Aprende Salud', path: '/aprende' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-white/64 hover:text-white text-sm transition-colors duration-200 inline-block hover:translate-x-1"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Ubicación y atención</h3>
            <div className="space-y-4 text-sm text-white/64">
              <p className="flex items-start gap-3">
                <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Nueva Esperanza, Canindeyú, Paraguay</span>
              </p>
              <Link to="/agenda" className="inline-flex items-center rounded-xl bg-white/10 border border-white/10 px-4 py-3 text-white hover:bg-white/15 transition-colors">
                Consultar agenda online
              </Link>
              <p className="text-xs text-white/48">
                Los datos de contacto se publican únicamente desde fuentes institucionales verificadas.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Plataforma</h3>
            <div className="bg-white/5 p-4 rounded-2xl border border-white/10 shadow-[0_2px_12px_rgba(0,0,0,0.08)]">
              <p className="text-xs text-white/48 font-medium mb-1">Tecnología</p>
              <div className="flex items-center gap-2 text-white font-bold">
                <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                QorIAX Health Systems
              </div>
              <p className="text-xs text-white/48 mt-2">
                Infraestructura digital multi-tenant para operaciones de salud.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/48">
            &copy; {currentYear} Centro Médico Santa Clara. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 text-sm text-white/48">
            <Link to="/privacidad" className="hover:text-white transition-colors duration-200">Privacidad</Link>
            <Link to="/terminos" className="hover:text-white transition-colors duration-200">Términos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
